import {Component} from '@angular/core';
import {ToastrService} from 'ngx-toastr';

import {BulkSettingsService} from 'OpsCenter/ops-support/settings/bulk-settings.service';
import {BulkSettingsUpdate} from "OpsCenter/ops-support/settings/bulk-settings-update";
import {MerchantCleanUpService} from "OpsCenter/ops-support/merchant-clean-up/merchant-clean-up.service";

@Component({
  selector: 'app-merchant-clean-up',
  template: require('./merchant-clean-up.component.html'),
  styles: [require('./merchant-clean-up.component.less')],
})
export class MerchantCleanUpComponent {
  public merchantId = null;

  constructor(private merchantCleanUpService: MerchantCleanUpService, private notificationService: ToastrService) {
  }

  deleteImportedCustomers() {
    if (this.confirmAction()) {
      return;
    }

    this.deleteCustomers('IMPORTED_ONLY');
  }

  deleteAllCustomers() {
    if (this.confirmAction()) {
      return;
    }

    this.deleteCustomers('ALL');
  }

  private deleteCustomers(type: string) {
    this.merchantCleanUpService
      .deleteCustomers(this.merchantId, type)
      .subscribe(this.handleUpdateSuccess(), this.handleUpdateFailure());
  }

  private handleUpdateSuccess() {
    return () => {
      this.notificationService.success('Customers deleted')
    };
  }

  private handleUpdateFailure() {
    return () => {
      this.notificationService.error('Failed to delete customers')
    };
  }

  private confirmAction() {
    return !window.confirm('Please confirm update operation');
  }
}



// WEBPACK FOOTER //
// ./src/app/ops-support/merchant-clean-up/merchant-clean-up.component.ts